import { createSelector } from 'reselect';
import { RootState } from '../configureStore';

const selectTranslationReducer = (state: RootState) => state.translation;

const selectCurrentLanguage = createSelector(selectTranslationReducer, (data) => data.translation);

export { selectCurrentLanguage };
